
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search } from "lucide-react";

interface OrderFiltersProps {
  searchTerm: string;
  statusFilter: string;
  dateFilter: string;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onDateChange: (value: string) => void;
}

const OrderFilters = ({ searchTerm, statusFilter, dateFilter, onSearchChange, onStatusChange, onDateChange }: OrderFiltersProps) => {
  const orderStatuses = ['all', 'pending', 'processing', 'shipped', 'delivered', 'cancelled'];
  const dateRanges = [
    { value: 'all', label: 'All time' },
    { value: '7', label: 'Last 7 days' },
    { value: '30', label: 'Last 30 days' },
    { value: '90', label: 'Last 90 days' },
  ];

  return (
    <div className="flex flex-col sm:flex-row gap-4">
      <div className="relative flex-grow">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search by Order #"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10 bg-transparent"
        />
      </div>
      <Select value={statusFilter} onValueChange={onStatusChange}>
        <SelectTrigger className="w-full sm:w-[180px] bg-transparent">
          <SelectValue placeholder="Filter by status" />
        </SelectTrigger>
        <SelectContent>
          {orderStatuses.map(status => (
            <SelectItem key={status} value={status} className="capitalize">
              {status === 'all' ? 'All Statuses' : status}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={dateFilter} onValueChange={onDateChange}>
        <SelectTrigger className="w-full sm:w-[180px] bg-transparent">
          <SelectValue placeholder="Filter by date" />
        </SelectTrigger>
        <SelectContent>
          {dateRanges.map(range => (
            <SelectItem key={range.value} value={range.value}>
              {range.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default OrderFilters;
